<template>

  <el-drawer v-model="drawerVisible" direction="rtl" :size="fullScreen?'100%': '70%'"
             :append-to-body="true" @close="handleClose" :show-close="false" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <template #header="{  titleId, titleClass,close }">
      <div :id="titleId" :class="titleClass" style="font-size: 16px;font-weight: bold;color: rgb(48,66,101)">
        <span v-if="form"> {{ form.name }} - {{ title }}</span>
      </div>

      <span>

      <el-button v-prevent-re-click
                 :icon="fullScreen?'Minus':'FullScreen'" type="info" link
                 style="font-size: 16px;"
                 @click="()=>{
                   formStore.setFullScreen(form.id,'edit');
                   fullScreen = formStore.getFullScreen(form.id,'edit');
                 }"></el-button>

      <el-button v-prevent-re-click icon="Close" type="info" link style="font-size: 20px;" @click="close()"></el-button>
      </span>


    </template>
    <template #default>

      <el-scrollbar height="calc(100vh - 100px)"
                    style="background-color: white;padding: 0 20px 0 20px; border-radius: 8px;"
                    v-loading="loading"
                    element-loading-text="努力加载中..."
                    class="form-container">
        <el-form v-if="form" ref="form" :model="data" :label-position="form.setting.style.PC.layout" label-width="auto"
                 style="height: 100%;margin-bottom: 20px">
          <template v-for="(element,index) in form.elements" :key="index">
            <keep-alive>
              <component v-if="authentication.isRead(element)" :ref="element.id"
                         v-show="!authentication.isHide(element,data)"
                         :is="`design${element.tag.charAt(0).toUpperCase() + element.tag.slice(1)}Preview`"
                         :element="element"
                         :context="{ form:form, data, parent:null,authentication}">
              </component>
            </keep-alive>
          </template>
        </el-form>
        <el-backtop :bottom="50" :right="60" target=".form-container .el-scrollbar__wrap"/>
      </el-scrollbar>

    </template>

    <template #footer>
      <div style="text-align: right;margin-right: 5px">
        <el-button v-prevent-re-click type="primary" @click="submit()" style="width: 80px" :disabled="!form" dark>提交
        </el-button>
        <el-button v-prevent-re-click @click="submitAndGoOn()" style="width: 100px" :disabled="!form" dark
                   type="success">
          提交并继续
        </el-button>
      </div>
    </template>

  </el-drawer>

</template>

<script>
import {mapStores} from "pinia";
import {useFormStore} from "@/stores/form";
import {useFormAuthenticationStore} from "@/stores/form-authentication";
import {useMenuStore} from "@/stores/menu";

export default {
  emits: ['callback'],
  computed: {
    ...mapStores(useFormStore, useMenuStore, useFormAuthenticationStore),
  },
  data() {
    return {
      drawerVisible: false,
      data: {},
      title: '新增',
      fullScreen: false,
      loading: false,
      //字段权限
      authentication: null,
      form: null,
    }
  },
  methods: {
    call(formId, data, sign) {

      if (!formId) {
        this.notify('消息', '无法获取表单id')
        return;
      }

      this.fullScreen = this.formStore.getFullScreen(formId,'edit');

      this.drawerVisible = true;
      this.$nextTick(() => {
        this.loading = true;

        this.menuStore.findById(formId).then(response => {
          let form = response.data;
          if (data) {

            if (sign === 'editor') {
              this.data = data;
              this.title = '编辑'
              this.authentication = this.formAuthenticationStore.edit(form);
            } else if (sign === 'copy') {
              this.data = this.deepClone(data);
              Object.keys(data).forEach(key => {
                if (key === 'id' || key.startsWith("_property")) {
                  delete this.data[key];
                }
              })
              this.title = '新增'
              this.authentication = this.formAuthenticationStore.add(form);
            }

          } else {
            this.data = this.formStore.initData(this.deepClone(form))
            this.authentication = this.formAuthenticationStore.add(form);
          }
          this.form = response.data;
          this.loading = false;
        })
      })
    },
    submitAndGoOn() {

      this.$messageBox.confirm(
          '当前操作将【发起表单流程】且当前页面【不会关闭】以供修改后【继续提交】，确定要这样做吗？',
          '提交并继续',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(() => {
        this.submit('continue');
      })
          .catch(() => {
          })


    },
    submit(sign) {


      const errorCallback = (message, field) => {
        this.message(message, 'error');
        this.loading = false;
        try {
          this.$refs[field][0].$el.firstElementChild.focus()
        } catch (e) {

        }

      }

      if (this.data.id) {
        this.authentication.validate(this.data, () => {
          this.loading = true;
          this.formStore.updateRow(this.form.id, this.data).then(res => {
            this.loading = false;
            if (res.code === 200) {
              this.drawerVisible = false;
              this.$emit('callback')
            }

          })
        }, errorCallback);

      } else {
        this.authentication.validate(this.data, () => {
          this.loading = true;
          this.formStore.postRow(this.form.id, this.data).then((res) => {
            this.loading = false;
            if (res.code === 200) {

              if (sign === 'continue') {
                this.$emit('callback');
                this.notify('消息', '提交成功', 'success');
              } else {
                this.drawerVisible = false;
                this.$emit('callback')
              }
            }
          })
        }, errorCallback);
      }
    },
    handleClose() {
      this.data = {};
      this.authentication = null;
      this.form = null;
    }
  }


}

</script>

<style lang="scss">


.el-drawer {
  background-color: #F5F7FA;

  .btn-full-screen {
    margin-right: 10px;
    padding: 2px 6px 3px 6px;
    font-weight: normal;
    color: #73767A
  }

  .form-container {
    background-color: white;
    padding: 0 20px 20px 20px;
    min-height: 100%;
    border-radius: 8px;

    .el-form {
      height: 100%;
      background-color: white;
      padding: 24px 20px 0 20px;
      border-radius: 10px
    }
  }
}

</style>